import React from "react";
import { useState,useEffect,useRef } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/SalespersonActivityReport.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
//import SalespersonSidebar from "./SalespersonSidebar";
import { format } from "date-fns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';



const columns = [
    {
        field: 'user_name',
        headerName: 'User Name',
        cellClassName:'user_name_column',headerClassName:'user_name_header',  
        flex:1,  
        sortable:false,
        renderCell: (params) => (
            <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.user_name}
            </Link>
        ),
    },
    {
        field: 'salesperson_name',
        headerName: 'Salesperson Name',  
        headerClassName:'slaesperson_name_header',    
        flex:1,
        sortable:false,
    },
    {
        field: 'event_subject',
        headerName: 'Event Subject',    
        headerClassName:'event_subject_header',
        flex:2,
        sortable:false,
        // minWidth: 265,
    },
    {
        field: 'event_details',
        headerName: 'Event Details',    
        headerClassName:'event_details_header',
        flex:2,
        sortable:false,
    },
    {
        field: 'event_created_date',
        headerName: 'Event Created Date',    
        headerClassName:'event_created_date_header',
        flex:1,
        sortable:false,
    },
];

const SalespersonActivityReport = () => {
     const initialSalespersonActivityForm = () => {
  const params = new URLSearchParams(window.location.search);

  const defaultForm = {
    start_date: '',
    end_date: '',
    start_date_obj: null,
    end_date_obj: null,
    salesperson: '',
    sortflags: [],
    action:''
  };

  const queryStart = params.get("start_date");
  const queryEnd = params.get("end_date");

   const startObj =
  queryStart
    ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
    : null;

const endObj =
  queryEnd
    ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
    : null;

        const sortflags = (() => {
        const values = [];

        for (const [key, value] of params.entries()) {
            if (key.startsWith("sortflags[")) {
            if (value) values.push(value);
            }
        }

        return values;
        })();
      //  const queryView = params.get("view") || '';
  return {
    ...defaultForm,

    start_date: startObj ? queryStart : '',
    start_date_obj: startObj,

    end_date: endObj ? queryEnd : '',
    end_date_obj: endObj,

    salesperson: params.get("salesperson") || defaultForm.salesperson,

    sortflags: sortflags,

   //  view: queryView,
    
     action: ''
  };
};

    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialSalespersonActivityForm());
    const [appliedFormData, setAppliedFormData] = useState(initialSalespersonActivityForm());
    const [formErrors, setFormErrors] =useState({});
    const[salespersonList, setSalespersonList] = useState({});
    const[sortflagList, setSortflagList] = useState({});
    const[activitycount, setActivityCount] = useState({});
    const[apptouchcount, setAppTouchCount] = useState({});
    
    const[appcount, setAppCount] = useState({});
    const[dateofappcount, setDateofAppCount] = useState({});
    const[averagesales, setAverageSales] = useState({});
    const[averageevent, setAverageEvent] = useState({});
    const [submittedData, setSubmittedData] = useState(null);
    const[selectedsf, setSelectedsf] = useState('');
   

    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [isSubmitted, setIsSubmitted] = useState(false);
    
    

    const app_url = configData.APP_URL;

    const formRef = useRef(null);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSortFlagFocusChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, sortflags: selectedValues }));
    };

    // const handleStartDateChange = (date) => {
    //   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
    //   setFormData(prev => ({ ...prev, start_date: formattedDate }));
    // };
    // const handleEndDateChange = (date) => {
    //   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
    //   setFormData(prev => ({ ...prev, end_date: formattedDate }));
    // };
    const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // for DatePicker
    [field]: date ? format(date, 'yyyy-MM-dd') : '' // for backend
  }));
};
      const validateDates = (formData) => {
    let errors = {};

    if (!formData.start_date) {
      errors.start_date = "Start date is required.";
    }

    if (!formData.end_date) {
      errors.end_date = "End date is required.";
    }

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }

    return errors;
  };

    useEffect(() => {
        getsalespersonlist(); 
        retrieveSortFlags();    
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000); 

        return () => clearTimeout(timer); 
    },[]); 



    async function  retrieveSortFlags() {
    
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'sortflag/getsortflaglist',
                {
                    method: "GET",
    
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setSortflagList(responsedata.data.result);
            }
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    }

    async function getsalespersonlist() {
        try {
            const response = await fetch(
                app_url+'user/getsalespersonlistwithunassigned',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }    
    }

     React.useEffect(() => {
              if(formData.start_date && formData.end_date) {
                  const fetchData = async () => {
                  // Simulate API call to your server
                   // In a real application, replace this with your actual fetch logic
             try {
              setIsLoading(true);
            const response = await fetch(app_url+'activityreport/getlist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                //formData:formData
                 formData: {
                    ...appliedFormData,
                    action: isSubmitted ? 'submit' : ''
                }
              }),
            });
            const data = await response.json();
            // console.log(data?.data?.rows ?? []);
            setRows(data.data.rows);
            // setRows(data?.data?.rows ?? []);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
            // setRowCount(data?.data?.totalRowCount ?? []);
            // setSelectedsf(data?.data?.selected_sf ?? null);
            setSelectedsf(data.data.selected_sf);
            setActivityCount(data.data.activity_count);
            setAppTouchCount(data.data.app_touch_count);
            setAppCount(data.data.app_count);
            setDateofAppCount(data.data.date_of_app_count);
            setAverageSales(data.data.avg_sales_count);
            setAverageEvent(data.data.avg_event_count);
            }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                   if (isSubmitted) {
                   setIsSubmitted(false);
                  }
                }
                
          };
          
      
          fetchData();
        }
            }, [paginationModel, sortModel, filterModel, appliedFormData]); // Re-fetch data when these change 
      
          const handleSubmit = async (e) => {
              e.preventDefault(); // stop page reload
               const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
              setSubmittedData(formData);
               setAppliedFormData({...formData});
              // Reset pagination state
                setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
            //   console.log("Selected sortflag:", formData.sortflags);
            setIsSubmitted(true);
        //    try {
        //       setIsLoading(true);
        //     const response = await fetch(app_url+'activityreport/getlist', {
        //       method: 'POST',
        //       headers: { 'Content-Type': 'application/json' },
        //       body: JSON.stringify({
        //         page: 0,
        //         pageSize: 50,
        //         sortModel,
        //         filterModel,
        //         formData:formData
        //       }),
        //     });
        //     const data = await response.json();
            
        //     setRows(data.data.rows);
        //     // console.log("Rows received:", rows);
        //     // setRows(data?.data?.rows ?? []);
        //     setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        //     // setRowCount(data?.data?.totalRowCount ?? []);
        //     // setSelectedsf(data?.data?.selected_sf ?? null);
        //     setSelectedsf(data.data.selected_sf);
        //     setActivityCount(data.data.activity_count);
        //     setAppTouchCount(data.data.app_touch_count);
        //     setAppCount(data.data.app_count);
        //      setAverageSales(data.data.avg_sales_count);
        //     setAverageEvent(data.data.avg_event_count);
        //     setDateofAppCount(data.data.date_of_app_count);
        //     }  catch (error) {
        //           console.error('Error fetching data:', error);
        //         } finally {
        //           setIsLoading(false); // Set loading to false after fetch completes (success or error)
        //         }
         
          
          };

    const handleExport = async (e) => {
        e.preventDefault(); // stop page reload
         const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});

        if (formRef.current && formRef.current.reportValidity()) {
   
        try {
            setIsLoading(true);
            const response = await fetch(app_url+'activityreport/getexport', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    formData:formData
                }),
            });
            const data = await response.json();
    const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
        } else { 

        }
    };
    const submitFormData = async (data) => {
      setSubmittedData(data);
      setAppliedFormData(data);
      setIsSubmitted(false);
    };
    
    // useEffect(() => {
    //   const params = new URLSearchParams(window.location.search);
    
    //   if ([...params.keys()].length > 0) {
    //     const init = initialSalespersonActivityForm();
    
    //     setFormData(init);
    
    //     submitFormData(init);              
    //   }
    // }, []);
            const normalizeBackendData = (backendParams) => {
              return {
                ...backendParams,
            
                start_date_obj: backendParams.start_date
                  ? new Date(backendParams.start_date.replace(/-/g, "/") + " 00:00:00")
                  : null,
            
                end_date_obj: backendParams.end_date
                  ? new Date(backendParams.end_date.replace(/-/g, "/") + " 00:00:00")
                  : null,
              };
            };
            
            useEffect(() => {
              const params = new URLSearchParams(window.location.search);
              const reportViewId = params.get("report_view_id");
            
              const baseForm = initialSalespersonActivityForm(); 
            
              if (reportViewId) {
                const fetchData = async () => {
                  try {
                    const res = await fetch(app_url + 'report/getreportfilters', {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({ id: reportViewId }),
                    });
            
                    const data = await res.json();
                    const backendParams = data?.data?.params || {};
            
                    //  normalize backend
                    const normalized = normalizeBackendData(backendParams);
            
                    //  merge (backend overrides URL/defaults)
                    const finalData = {
                      ...baseForm,
                      ...normalized,
                    };
            
                    setFormData(finalData);
                    submitFormData(finalData);
            
                  } catch (err) {
                    console.error(err);
                  }
                };
            
                fetchData();
              } else {
                //  fallback → only URL/default
                if ([...params.keys()].length > 0) {
                  setFormData(baseForm);
                  submitFormData(baseForm);
                }
              }
            
            }, []);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main" className="salesperson-activity-report-main">
                    <Helmet><title>Salesperson Activity Report</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="salesperson-activity-container">
                            <h1>Salesperson Activity Report</h1>
                            <div className="messages_details">
                                <ul>
                                    <li><strong>Activity Count:</strong> The number of users the salesperson has contacted or updated each day
                                        <ul>
                                        <li>Calculation:  1 count per day for each user the salesperson has logged an event for in the date range</li>
                                        <li>Excludes “User Profile Updated” event</li>
                                        </ul>
                                    </li>
                                    <li><strong>Apps Touched:</strong> The number of users the salesperson has contacted or updated
                                        <ul>
                                        <li>Calculation: 1 count per user the salesperson has logged an event for in the date range</li>
                                        <li>Excludes “User Profile Updated” event</li>
                                        </ul>
                                    </li>
                                    <li><strong>New Apps:</strong> The number of new users in ecom assigned to the salesperson
                                        <ul>
                                        <li>Calculation: Apps with Created Date in the date range</li>
                                        </ul>
                                    </li>
                                    <li><strong>Total Apps:</strong> The number of new users and updated existing users assigned to the salesperson
                                    <ul>
                                        <li>Calculation: Apps with Date of App in the date range</li>
                                        </ul>
                                    </li>
                                    <li><strong>Average # Days for Sale:</strong> The average number of days until users make their first payment.
                                    <ul>
                                        <li><strong>Calculation:</strong> The following formula, but only pulling paid users with a created date in the date range --&gt; (first payment date - created date) / # of users</li>
                                        </ul>
                                    </li>
                                    <li><strong>Average # Event Logs for Sale:</strong> The average number of events until users make their first payment.
                                    <ul>
                                        <li><strong>Calculation:</strong> The following formula, but only pulling paid users with a created date in the date range --&gt; # of events between first payment date and created date / # of users</li>
                                        </ul>
                                    </li>
                                </ul>	
                            </div>
                            <form onSubmit={handleSubmit} ref={formRef}>
                                <div className="form-item">
                                    <label>Event Start Date</label>
                                    <DatePicker
                                        ref={startDateRef}
                                        selected={formData.start_date_obj}
                                        onChange={(date) => {handleDateChange(date, 'start_date');
                                                setTimeout(() => {
                                                const input = startDateRef.current?.input;
                                                if (input) {
                                                const len = input.value.length;
                                                input.setSelectionRange(len, len);
                                                }
                                            }, 0);
                                        }}
                                        id="start_date"
                                        name="start_date" 
                                        className=""
                                        //required 
                                    /> 
                                       {formErrors.start_date && (
                    <div className="error">{formErrors.start_date}</div>
                  )} 
                                </div>
                                <div className="form-item">
                                    <label>Event End Date</label>
                                    <DatePicker
                                        ref={endDateRef}
                                        selected={formData.end_date_obj}
                                        onChange={(date) => {handleDateChange(date, 'end_date');
                                                setTimeout(() => {
                                                const input = endDateRef.current?.input;
                                                if (input) {
                                                const len = input.value.length;
                                                input.setSelectionRange(len, len);
                                                }
                                            }, 0);
                                        }}
                                        id="end_date"
                                        name="end_date" 
                                        className=""
                                      //  required 
                                    /> 
                                       {formErrors.end_date && (
                    <div className="error">{formErrors.end_date}</div>
                  )}  
                                </div>
                                <div className="form-item">
                                    <select 
                                        id="salesperson" 
                                        name="salesperson" 
                                        style={{width:"300px",border:"1px solid #ccc",padding: "2px"}}
                                        onChange={handleChange}
                                        value={formData.salesperson}
                                    >
                                        <option value="ALL">ALL</option>
                                        {salespersonList.length > 0 && (
                                            <>
                                                {salespersonList.map((item) => {
                                                    return <>
                                                        {item['uid'] != null && (
                                                            <><option value={item['uid']}>{item['name']}</option></>
                                                        )}
                                                    </>
                                                })}  
                                            </>
                                        )}
                                      
                                    </select>
                                </div>
                                <div className="form-item">
                                    <label>SortFlags</label>
                                    <select 
                                        name="sortflags" 
                                        multiple={true}
                                        size="15" 
                                       
                                        onChange={handleSortFlagFocusChange}
                                        value={formData.sortflags || []}
                                        style={{width:"793px"}}
                                    >
                                        {sortflagList.length > 0 && (
                                            <>
                                                {sortflagList.map((item) => {
                                                    return <>
                                                        {item['id'] != null && (
                                                            <><option value={item['id']}>{item['name']}</option></>
                                                        )}
                                                    </>
                                                })}  
                                            </>
                                        )}
                                    </select>
                                </div>
                                <div className="form-item">
                                    <input type="submit" name="" value="Submit" className="form-submit" /> 
                                    <input type="button" name="" value="Export" className="form-submit" onClick={handleExport} />
                                    <a href="/admin/reports/event_log">
                                        <input type="button" name="" value="Clear" className="form-submit" />
                                    </a>
                                </div>
                            </form>
                            {submittedData && (
                                <div>
                                    <>
                                        <div>
                                            <b>Sort Flags:</b>
                                            <span>
                                                {selectedsf}
                                            </span>
                                        </div>
                                        <div className="salesperson-activity-content">
                                            <table className="salesperson-activity-table" style={{width: "99%"}}>
                                                <tr>
                                                    <th>Salesperson</th>
                                                    <th>Activity Count</th>
                                                    <th>Apps Touched</th>
                                                    <th>NEW APPS</th>
                                                    <th>Total APPS</th>
                                                    <th>Average # days for sale</th>
                                                    <th>Average # event logs for sale</th>
                                                </tr>
                                                {salespersonList.length > 0 && (
                                            <>
                                                {salespersonList.map((citem) => (
                                                    <tr>
                                                    <td>{citem['name']}</td>
                                                    {activitycount?.[citem['uid'] ?? 0] ? (
                                                    <>
                                                    <td>{activitycount?.[citem['uid'] ?? 0]}</td>
                                                   </>
                                                    ) : (
                                                       <>
                                                    <td>0</td>
                                                    </> 
                                                    )
                                                    }
                                                     {apptouchcount?.[citem['uid'] ?? 0] ? (
                                                    <>
                                                    <td>{apptouchcount[citem['uid'] ?? 0]}</td>
                                                   </>
                                                    ) : (
                                                       <>
                                                    <td>0</td>
                                                    </> 
                                                    )
                                                    }
                                                   
                                                     {appcount?.[citem['uid'] ?? 0] ? (
                                                    <>
                                                    <td>{appcount?.[citem['uid'] ?? 0]}</td>
                                                   </>
                                                    ) : (
                                                       <>
                                                    <td>0</td>
                                                    </>
                                                    )
                                                    }
                                                    
                                                    {dateofappcount?.[citem['uid'] ?? 0] ? (
                                                    <>
                                                    <td>{dateofappcount?.[citem['uid'] ?? 0]}</td>
                                                   </>
                                                    ) : (
                                                       <>
                                                    <td>0</td>
                                                    </>
                                                    )
                                                    }
                                                   {averagesales?.[citem['uid'] ?? 0] ? (
                                                    
                                                    <>
                                                    <td>{averagesales[citem['uid']]}</td>
                                                   </>
                                                   
                                                    ) : (
                                                       <>
                                                    <td>0</td>
                                                    </>
                                                    )
                                                    }
                                                    {averageevent?.[citem['uid']??0] ? (
                                                    
                                                    <>
                                                    <td>{averageevent[citem['uid']]}</td>
                                                   </>
                                                    
                                                    ) : (
                                                       <>
                                                    <td>0</td>
                                                    </>
                                                    )
                                                    }
                                                    </tr>
                                                        
                                                   
                                                ))}  
                                                <tr><td>Total</td><td>{activitycount?.['total']}</td><td>{apptouchcount?.['total']}</td><td>{appcount?.['total']}</td>
                                                <td>{dateofappcount?.['total']}</td><td></td><td></td></tr>
                                            </>
                                        )}
                                            </table>
                                        </div>
                                    </>
                                    <>
                                        <div id="total_apps" style={{marginTop:"10px", marginRight:"17px"}}>Total Apps: {dateofappcount['total']}</div>
                                        <div className="salesperson-event-content">
                                            <table className="salesperson-event-table">
                                                <div>
                                                    <DataGrid
                                                        rows={rows}
                                                                                                   columns={columns}
                                                                                                   rowCount={rowCount}
                                                                                                   paginationMode="server"
                                                                                                   sortingMode="server"
                                                                                                   filterMode="server"
                                                                                                   paginationModel={paginationModel}
                                                                                                   onPaginationModelChange={setPaginationModel}
                                                                                                   sortModel={sortModel}
                                                                                                   onSortModelChange={setSortModel}
                                                                                                   filterModel={filterModel}
                                                                                                   onFilterModelChange={setFilterModel}
                                                                                                   pageSizeOptions={[5, 10, 25,50]}
                                                                                                   getRowId={() => crypto.randomUUID()}
                                                                                                   getRowHeight={() => 'auto'}
                                                                                                   disableColumnFilter 
                                                                                                   // disableColumnResize={true}
                                                                                               />
                                                </div>
                                            </table>
                                        </div>
                                    </>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="right">
                        {/* <SalespersonSidebar /> */}
                    </div>
                </div>
            )}
        </>
    );
};
export default SalespersonActivityReport;